import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=290b18fa&scoped=true&"
import script from "./HistoryModal.vue?vue&type=script&lang=js&"
export * from "./HistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoryModal.vue?vue&type=style&index=0&id=290b18fa&lang=scss&scoped=true&"
import style1 from "./HistoryModal.vue?vue&type=style&index=1&id=290b18fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290b18fa",
  null
  
)

export default component.exports